export default __webpack_public_path__ + "static/media/4_4.07753c25.jpg";